/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';
import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  IconButton,
  TablePagination,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { formatDateOnly } from '../utils/dateTime';

function ProprietarioList({ refresh, onEdit, onDeleted, nomeFilter, imovelIdFilter }) {
  const { user } = useAuth();
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  const fetchRows = () => {
    let query = `/proprietarios?page=${page}&limit=${rowsPerPage}`;
    if (nomeFilter) query += `&search=${nomeFilter}`;
    if (imovelIdFilter) query += `&imovelId=${imovelIdFilter}`;

    api.get(query)
      .then((response) => {
        setRows(response.data.data);
        setTotalCount(response.data.totalCount);
      })
      .catch((error) => console.error('Erro ao buscar proprietarios:', error));
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    fetchRows();
  }, [refresh, page, rowsPerPage, nomeFilter, imovelIdFilter]);

  const handleDelete = async (id) => {
    if (!window.confirm('Tem certeza que deseja deletar este proprietario?')) return;
    try {
      await api.delete(`/proprietarios/${id}`);
      onDeleted();
      fetchRows();
    } catch (error) {
      console.error('Erro ao deletar proprietario:', error);
    }
  };

  return (
    <Paper>
      <TableContainer>
        <Table sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow>
              {(user && user.tipo_usuario === 'admin') && <TableCell>Empresa ID</TableCell>}
              <TableCell>Chave</TableCell>
              <TableCell>Imovel</TableCell>
              <TableCell>Pessoa</TableCell>
              <TableCell>Início</TableCell>
              <TableCell>Fim</TableCell>
              <TableCell>Dono Atual</TableCell>
              <TableCell>Acoes</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.id} hover>
                {(user && user.tipo_usuario === 'admin') && <TableCell>{row.empresa_id}</TableCell>}
                <TableCell>{row.chave || String(row.id).padStart(4, '0')}</TableCell>
                <TableCell>{row.imovel_numero ? `Unid. ${row.imovel_numero} - ${row.imovel_descricao}` : 'N/A'}</TableCell>
                <TableCell>{row.pessoa_nome || 'N/A'}</TableCell>
                <TableCell>{formatDateOnly(row.data_inicio, user)}</TableCell>
                <TableCell>{formatDateOnly(row.data_fim, user)}</TableCell>
                <TableCell>{row.data_fim ? 'Não' : 'Sim'}</TableCell>
                <TableCell>
                  <IconButton aria-label="edit" onClick={() => onEdit(row)}>
                    <EditIcon />
                  </IconButton>
                  <IconButton aria-label="delete" onClick={() => handleDelete(row.id)}>
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={totalCount}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={(event, newPage) => setPage(newPage)}
        onRowsPerPageChange={(event) => {
          setRowsPerPage(parseInt(event.target.value, 10));
          setPage(0);
        }}
      />
    </Paper>
  );
}

export default ProprietarioList;


